const loadedFontKeys = new Set<string>();

const FONT_FILE_OVERRIDES: Record<string, string> = {
  Calibri: "carlito"
};

function toKebabCase(fontName: string): string {
  return fontName.toLowerCase().replace(/ /g, "-");
}

function loadFontFace(fontName: string, weight: number): void {
  const key = `${fontName}:${weight}`;
  if (loadedFontKeys.has(key)) return;
  loadedFontKeys.add(key);

  const fileKey = FONT_FILE_OVERRIDES[fontName] ?? toKebabCase(fontName);
  const url = `/fonts/${fileKey}/${fileKey}-latin-${weight}.woff2`;

  const face = new FontFace(fontName, `url(${url})`, {
    weight: String(weight),
    style: "normal",
    display: "swap"
  });

  face.load().then(
    (loaded) => document.fonts.add(loaded),
    () => {
      loadedFontKeys.delete(key);
    }
  );
}

/**
 * Loads font families at weight 400 from local woff2 files for font name previews.
 */
export function loadFontsForPreview(fontNames: string[]): void {
  for (const fontName of fontNames) {
    loadFontFace(fontName, 400);
  }
}

/**
 * Loads all standard weights (100–900) for a single font family
 * so the font weight dropdown can preview each weight.
 */
export function loadFontWeightsForPreview(fontName: string): void {
  for (let weight = 100; weight <= 900; weight += 100) {
    loadFontFace(fontName, weight);
  }
}
